var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvglimpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 485.16 487.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.cls-1,.cls-2{fill:none;}\r\n.cls-2{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:10px;}\r\n.cls-3{clip-path:url(#clip-path);}\r\n"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.68,405.57h38.17l13.78,9.5V433.2l-7,7.37,15,13v34l139-3,35-13,11-29,8-110-11-28-39.74-24-103.26-1s-41.45-4-64.23,1-31.66,9-31.66,9l-19.11,32,2,46Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Limpi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.36,61c8.86-16.14,2.11-36.87-15.08-46.3s-38.3-4-47.16,12.14L54,167.43C41.62,189.94,51,218.85,75,232s53.41,5.57,65.76-16.94Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.98,
    y1: 328.62,
    x2: 157.34,
    y2: 81.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.63,53.57s46-4,46,48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.66,100.54s-4-46,48-46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.63,54.5s46,4,46-48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.66,7.54s-4,46,48,46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.63,53.57s46-4,46,48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.66,100.54s-4-46,48-46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.63,54.5s46,4,46-48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.66,7.54s-4,46,48,46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.63,312.57s46-4,46,48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.66,359.54s-4-46,48-46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.63,313.5s46,4,46-48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.66,266.54s-4,46,48,46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 252.43,
    y1: 10.03,
    x2: 119.63,
    y2: 402.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 291.74,
    y1: 10.03,
    x2: 157.34,
    y2: 405.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 200.46,
    y1: 163.62,
    x2: 235.55,
    y2: 175.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.97,
    y1: 221.23,
    x2: 216.61,
    y2: 231.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.63,
    y: 405.57,
    width: 250,
    height: 34,
    rx: 13.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.63,
    y1: 476.57,
    x2: 33.63,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.88,
    y1: 476.57,
    x2: 64.88,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.14,
    y1: 476.57,
    x2: 96.14,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.4,
    y1: 476.57,
    x2: 127.4,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.66,
    y1: 476.57,
    x2: 158.66,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 189.91,
    y1: 476.57,
    x2: 189.91,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.17,
    y1: 476.57,
    x2: 221.17,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 252.43,
    y1: 476.57,
    x2: 252.43,
    y2: 439.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 230.63,
    y: 280.57,
    width: 216,
    height: 33,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 235.63,
    y: 313.57,
    width: 204,
    height: 155,
    rx: 20.14
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "447.63 313.57 469.63 405.57 303.63 405.57 264.63 313.57"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 392.63,
    cy: 226.57,
    r: 17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 314.63,
    y1: 181.57,
    x2: 314.63,
    y2: 256.57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "437.63 278.06 437.63 198.13 409.23 158.31 409.23 124.24 375.63 124.24 375.63 158.31 347.23 198.13 347.23 278.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 375.63,
    y1: 124.24,
    x2: 351.57,
    y2: 124.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M409.23,124.24h19.45s9.95,18.33,10.95,38.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.5,281.29V175.43s5-32,34.56-32h49s34.18,2.54,34.18,44.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "276.17 143.41 276.17 105.07 314.63 105.07 314.63 143.41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvglimpi);
export default __webpack_public_path__ + "static/media/svglimpi.1e225840834fa0f60c77a04efaf539cc.svg";
export { ForwardRef as ReactComponent };